import {useMutation, useQuery} from "@apollo/client"
import React, {useState} from "react"
import {Link, Navigate, useParams} from "react-router-dom"
import SpinLoader from "../../components/loaders/SpinLoader"
import UserForm from "./form/UserForm"
import {UPDATE_CLIENT} from "./graphql/mutation"
import {GET_USER} from "./graphql/query"
import NotFound from "../../pages/NotFound"
import {toast} from "react-hot-toast"

export default function EditConsumerScreen() {
  const params = useParams()

  const [user, setUser] = useState()
  const {loading: userLoading} = useQuery(GET_USER, {
    variables: {
      id: parseInt(params?.id),
    },
    fetchPolicy: "network-only",
    onCompleted: (u) => {
      if (u?.GetUser) {
        setUser(u.GetUser)
      }
    },
  })

  const [UpdateClient, {loading, data}] = useMutation(UPDATE_CLIENT)
  const submitForm = async (values) => {
    await UpdateClient({
      variables: {
        id: parseInt(params.id),
        password: values.password,
        firstname: values.firstname,
        lastname: values.lastname,
        businessName: values.businessName,
        phone: values.phone,
        clientDescription: values.clientDescription,
        businessDescription: values.businessDescription,
        numberOfStores: values.numberOfStores?.toString(),
        specialInstructions: values.specialInstructions,
        shippingAddress: values.shippingAddress,
        billingAddress: values.billingAddress,
        website: values.website,
      },
      onCompleted: (data) => {
        if (data?.updateClient) {
          toast.success("Хадгалагдлаа")
        }
      },
    })
  }

  if (userLoading) return "Уншиж байна ..."
  if (!user) return <NotFound />
  return (
    <div className="page-wrapper">
      <div className="gh-canvas-header">
        <div className="gh-canvas-header-content">
          <div className="flex flex-column">
            <div className="gh-canvas-breadcrumb">
              <Link to="/consumers">Харилцагчид</Link>
              <svg viewBox="0 0 18 27">
                <path
                  d="M2.397 25.426l13.143-11.5-13.143-11.5"
                  strokeWidth="3"
                  stroke="#0B0B0A"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              Засах
            </div>
            <h2 className="gh-canvas-title">
              <a href="#_" className="active ">
                Хэрэглэгч засах
              </a>
            </h2>
          </div>
        </div>
      </div>
      <div className="position-relative">
        <SpinLoader loading={loading} absolute />
        <UserForm user={user} submitForm={submitForm} />
      </div>
    </div>
  )
}
